import React from 'react';

const CarAnexos2 = props => {
  let resolucionPantalla = {
    ancho: window.screen.width,
    alto: window.screen.height
  };
  
  let ancho=resolucionPantalla.ancho*0.95
  let alto=resolucionPantalla.alto*1.95
  return (
    <div>
      <iframe width={ancho} height={alto} src="https://lookerstudio.google.com/embed/reporting/ab833531-0092-44ad-9e83-f6aba7324803/page/p_aln4f1mk4c" ></iframe>
    </div>
  )
}

export default CarAnexos2